import { EMOTE_IDS, type EmoteId } from '@veriverse/shared';

/** Pointer closer than this to the wheel's centre (fraction of the outer radius) selects nothing. */
export const DEAD_ZONE = 0.3;

/** True while the wheel is held open: the world scene then ignores movement keys. */
let open = false;
export const emoteWheelOpen = (): boolean => open;
export const setEmoteWheelOpen = (value: boolean): void => {
  open = value;
};

/**
 * Which segment a point at (`dx`, `dy`) from the wheel's centre (y down) is in, counted from the
 * top clockwise, or `undefined` in the dead zone in the middle.
 */
export function segmentAt(dx: number, dy: number, outerRadius: number): number | undefined {
  if (Math.hypot(dx, dy) < outerRadius * DEAD_ZONE) return undefined;
  const turn = (Math.atan2(dx, -dy) / (2 * Math.PI) + 1) % 1; // 0 at the top, clockwise
  const size = 1 / EMOTE_IDS.length;
  return Math.floor(((turn + size / 2) % 1) / size);
}

/** The segment an arrow key moves to: left/up step back, right/down step forward. */
export function stepSegment(current: number | undefined, delta: 1 | -1): number {
  const count = EMOTE_IDS.length;
  if (current === undefined) return delta === 1 ? 0 : count - 1;
  return (current + delta + count) % count;
}

export const emoteAt = (segment: number | undefined): EmoteId | undefined =>
  segment === undefined ? undefined : EMOTE_IDS[segment];
